module.exports = __webpack_public_path__ + "static/media/varify-badge-step3-mobile.1d9c8309.png";